<template>
    <b-modal id="shipping-plan-modal"
             title="Choose shipping plan"
             @show="showModal"
             @hide="$emit('hide')"
             size="sm"
             title-tag="h6"
             footer-class="justify-content-center">
        <div v-if="$store.state.loading" class="d-flex justify-content-center">
            <b-spinner class="align-middle text-info"/>
        </div>
        <b-form-group v-if="plans && !$store.state.loading"
                      label-class="pl-0"
                      label="Add to an existing shipping plan">
            <b-form-radio-group
                class="pl-3 checkbox-wrap"
                @change="newPlan = false"
                :stacked="true"
                v-model="selectedPlan"
                :options="plans"
                name="shipping-plan"/>
        </b-form-group>
        <b-form-checkbox
            v-model="newPlan"
            @change="selectedPlan = -1"
            name="create-plan">
            Create a new shipping plan
        </b-form-checkbox>
        <template slot="modal-footer">
            <b-btn variant="primary-user"
                   :disabled="isDisabled"
                   @click="newPlan ? createPlan() : addToPlan()">Continue
            </b-btn>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: 'ShippingPlanModal',
        props: {
            items: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                plans: [],
                selectedPlan: -1,
                newPlan: false
            }
        },
        computed: {
            isDisabled() {
                if (!this.newPlan && this.selectedPlan < 0 && this.$store.state.loading) {
                    return true
                }
            }
        },
        methods: {
            showModal() {
                this.selectedPlan = -1
                this.newPlan = false
                this.getPlans()
                this.$emit('show')
            },
            getPlans() {
                this.$store.dispatch('getPlans').then(response => {
                    if (response.items.length > 0) {
                        this.plans = response.items.map(item => {
                            return {
                                value: item.id,
                                text: `Plan ID №${item.id}`
                            }
                        })
                    } else {
                        this.newPlan = true
                        this.createPlan()
                    }
                })
            },
            addToPlan() {
                let arr = this.items.map(item => {
                    if (typeof item === 'number') {
                        return { productId: item, quantity: 1 }
                    }
                    if (typeof item === 'object') {
                        return { productId: item.id, quantity: item.quantity }
                    }
                    return {}
                })
                this.$helper.multipleRequests({
                    method: 'POST',
                    url: this.$endpoints.incomesItems(this.selectedPlan),
                    // arr: this.items.map(item => ({productId: item, quantity: 1}))
                    arr
                }).finally(() => {
                    this.$emit('done', this.selectedPlan)
                    this.$root.$emit('bv::hide::modal', 'shipping-plan-modal')
                })
            },
            createPlan() {
                this.$store.dispatch('createPlan').then(response => {
                    this.selectedPlan = response.id
                    this.addToPlan()
                })
            }
        }
    }
</script>

<style lang="scss">
    .checkbox-wrap {
        max-height: 300px;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Modals/ShippingPlanModal.vue